<template>
  <div class="welfareTicketContent">
    <div class="title">
      <div class="vanImgContent">
        <van-image
          class="vanImg"
          round
          fit="cover"
          :src="
            type === 'all'
              ? require('@/assets/allPlatWelfare.svg')
              : ticketArr[0] || require('@/assets/setting/avatar.png')
          "
        />
      </div>
      <div class="text">
        {{ type === 'all' ? '全平台福利' : type }}
      </div>
    </div>
    <slot name="ticketContent" class="ticketContent"></slot>
  </div>
</template>

<script>
import { Image as VanImage } from 'vant'
export default {
  name: 'welfareTicketContent',
  components: { VanImage },
  props: {
    type: {
      type: String,
      default: null,
    },

    ticketArr: {
      type: Array,
      default: () => [],
    },
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.welfareTicketContent {
  margin: 24px;
  padding: 22px;
  background: #ffffff;
  box-shadow: 0px 8px 16px 0px rgba(152, 152, 152, 0.06);
  border-radius: 12px;

  .title {
    font-size: 22px;
    display: flex;
    margin-bottom: 20px;
    .vanImgContent {
      width: 40px;
      height: 40px;
      margin-right: 20px;
      align-items: center;
      .vanImg {
        width: 100%;
        height: 100%;
      }
    }
    .text {
      display: flex;
      align-items: center;
    }
  }
}
</style>
